<div class="modal-header d-flex align-items-center justify-content-between">
    <h4 class="modal-title">Save Planogram State</h4>
    <button type="button" class="btn btn-link p-0 border-0" aria-label="Close" (click)="activeModal.dismiss()">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>
  <div class="modal-body p-3">
    <form>
      <div class="d-flex align-items-center gap-2">
        <label for="save-name" class="form-label text-nowrap mb-0">Save Name:</label>
        <input type="text" class="form-control" id="save-name" name="saveName" [(ngModel)]="saveName">
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="confirm()">Confirm</button>
    <button type="button" class="btn btn-light" (click)="cancel()">Cancel</button>
  </div>
